import { render, staticRenderFns } from "./ListMaterialsSelected.vue?vue&type=template&id=1fabfc4e"
import script from "./ListMaterialsSelected.vue?vue&type=script&lang=js"
export * from "./ListMaterialsSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports